'use strict';

function valueIsNotInfinite(m) {
  return m !== -Infinity && m !== Infinity;
}

module.exports = valueIsNotInfinite;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/range/internal/valueIsNotInfinite.js
// module id = 861
// module chunks = 0